import { Logger, LoggerService } from '@Shared/logger';
import { Auth0Service } from '@Modules/auth_module';
import { PipelineContext, PipelineStep } from '@Modules/pipeline_module/_base';
import { Bus } from '@Modules/event_module';
import { APP_EVENTS } from '@Core';

import { ScreenManager } from '@Modules/ui_module';
import { OptionsModule } from '@Modules/options_module';

import { CheckAuthStatusStep } from './check-auth-status.step';

export class RegisterStep implements PipelineStep {
  private auth0Service: Auth0Service;

  private email: string;
  private password: string;

  constructor(email: string, password: string) {
    this.email = email;
    this.password = password;
  }

  private Logger: Logger = LoggerService.createLogger('LoginStep');
  async execute(context: PipelineContext): Promise<PipelineStep | null> {
    this.Logger.trace('Executing....', context);
    this.auth0Service = Auth0Service.Instance;
    const screenManager = ScreenManager.Instance;
    context.isFromLoginOrRegister = true;
    const options = OptionsModule.Options.ui.screens.register;
    const regRes = await this.auth0Service.register(this.email, this.password);
    context.onRegister = { page: location.href, result: regRes };
    if (regRes.success) {
      this.Logger.trace('Register successful');

      screenManager.CurrentScreen.Alert.success(
        options.formOptions.successMessage || 'Registration Successful',
      );
      return new CheckAuthStatusStep();
    } else {
      screenManager.CurrentScreen.Alert.error(regRes.error.message);
      screenManager.CurrentScreen.Form.enable();
      const errorMessage = regRes.error?.message?.toLowerCase() ?? '';
      if (
        errorMessage.includes('password is too weak') ||
        errorMessage.includes('passwordstrengtherror')
      ) {
        screenManager.CurrentScreen.Form.setFieldError('password');
      }
      return null;
    }
  }
}
